import { h, Component } from 'preact';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import Store from 'store/store';

import s from 'components/bolt/uarHeader/components/nav/nav.sss';

export default class Nav extends Component {
	render({ data, extraClass }) {
		const pages = data?.nav || {};
		return (
			<nav class={joinClasses(s.nav, extraClass)}>
				{sortObjectByOrder(pages).map(element => {
					const target = element.sameWindow ? '_self' : '_blank';
					if (element.path.match(/^http/)) {
						return (
							<a href={element.path} target={target} class={s.link}>
								{element.name}
							</a>
						);
					}
					return (
						<button
							class={s.link}
							onClick={() => Store.emit('SET_ACTIVE_PAGE', element.path)}
						>
							{element.name}
						</button>
					);
				})}
			</nav>
		);
	}
}